<div class="container">
  <div class="input-container">
    <label [attr.for]="label() || null" [ngClass]="{ required: required() }">
      {{ label() }}
      @if (required() && control().touched && control().invalid) {
        <span class="error-msg">Required</span>
      }
    </label>

    @switch (type().toLocaleLowerCase()) {
      @case ('text') {
        <input
          pInputText
          [attr.id]="label() || null"
          class="input-field"
          [style.width]="width()"
          aria-describedby="input-hint"
          [placeholder]="placeholder()"
          [formControl]="control()"
          [ngClass]="{ 'input-error': control().invalid && control().touched }"
          />
      }
      @case ('textarea') {
        <textarea
          pInputTextarea
          class="input-field"
          rows="8"
          cols="30"
          [placeholder]="placeholder()"
          [formControl]="control()"
          [ngClass]="{ 'input-error': control().invalid && control().touched }"
        ></textarea>
      }
      @case ('number') {
        <p-inputnumber
          [attr.id]="label() || null"
          class="input-field"
          [style.width]="width()"
          aria-describedby="input-hint"
          [placeholder]="placeholder()"
          [min]="min()"
          [max]="max()"
          [formControl]="control()"
          [ngClass]="{ 'input-error': control().invalid && control().touched }"
          />
      }
      @case ('decimal') {
        <p-inputnumber
          [attr.id]="label() || null"
          mode="decimal"
          [maxFractionDigits]="5"
          class="input-field"
          [style.width]="width()"
          aria-describedby="input-hint"
          [placeholder]="placeholder()"
          [min]="min()"
          [max]="max()"
          [formControl]="control()"
          [ngClass]="{ 'input-error': control().invalid && control().touched }"
          />
      }
      @case ('select') {
        <p-select
          [attr.id]="label() || null"
          aria-describedby="input-hint"
          [placeholder]="'Select One'"
          [emptyMessage]="emptyMessage()"
          [options]="selectOptions"
          [formControl]="control()"
          [styleClass]="
            'p-select-width' + (control().invalid && control().touched ? ' select-error' : '')
          "
          (onChange)="selectionChanged($event)"
          >
        </p-select>
      }
      @case ('date') {
        <p-datepicker
          [attr.id]="label() || null"
          class="input-field calendar-field"
          [style.width]="width()"
          [formControl]="control()"
          [showTime]="true"
          hourFormat="24"
          [placeholder]="placeholder()"
          [showIcon]="true"
          [ngClass]="{ 'input-error': control().invalid && control().touched }"
        ></p-datepicker>
      }
      @case ('time') {
        <p-datepicker
          [attr.id]="label() || null"
          class="input-field calendar-field"
          [style.width]="width()"
          [formControl]="control()"
          [showTime]="true"
          [timeOnly]="true"
          hourFormat="24"
          [placeholder]="placeholder()"
          [showIcon]="true"
          [ngClass]="{ 'input-error': control().invalid && control().touched }"
        ></p-datepicker>
      }
    }

    @if (hasHint) {
      <span style="font-size: 0.8em" class="input-hint">{{ hint() }}</span>
    }
    @if (hasBottomSpace) {
      <span style="font-size: 0.8em" class="input-hint">&nbsp;</span>
    }
  </div>
</div>
